import { jsxs as i, jsx as t } from "react/jsx-runtime";
const r = ({ size: o = 16, ...h }) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 40 40",
    fill: "none",
    ...h,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.5 13C5.5 11.067 7.067 9.5 9 9.5H31C32.933 9.5 34.5 11.067 34.5 13V14.5H5.5V13Z",
          fill: "#F0F5EE",
          stroke: "#4D6D6E"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.5 27C5.5 28.933 7.067 30.5 9 30.5H31C32.933 30.5 34.5 28.933 34.5 27V17.5H5.5V27Z",
          fill: "#F0F5EE",
          stroke: "#4D6D6E"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "5", y: "15", width: "30", height: "2", fill: "#4D6D6E" })
    ]
  }
);
export {
  r as CardLogoIcon
};
